/**
 * önce adding işlemleri sonra updating işlemleri yapılır
 */

import { filter, bufferTime } from "rxjs/operators";
import store from "@/store";
import log2 from "../utils/log2";
import { publishMessage, systemMessageStream } from "../utils/systemPubSub";
import chat from "../store/modules/chat";
import auth from "../store/modules/auth";

const log = log2("conversationsSyncWorker");

export const conversationsSyncWorker = () => {
    log.info("conversationsSyncWorker running");
    return systemMessageStream
        .pipe(
            filter((x) => ["conversation_destroy"].includes(x.type)),
            bufferTime(2000),
            filter((messages) => messages.length > 0)
        )
        .subscribe((messages) => {
            const { destroyed } = messages.reduce(
                (acc, cur) => {
                    if (cur.type === "conversation_destroy") acc.destroyed.push(cur.payload.id);
                    return acc;
                },
                {
                    destroyed: [],
                }
            );

            if (destroyed.length) {
                const idsMap = destroyed.reduce((acc, cur) => {
                    acc[cur] = true;
                    return acc;
                }, {});
                let chats = chat.state.conversations.filter((c) => idsMap[c._id]);
                let deletingChatIds = chats.map((x) => x._id);
                store.dispatch("chat/removeMultiConversation", deletingChatIds);
            }
        });
};
